import type { Moment } from 'moment';
import React, { Component, createRef, ReactNode } from 'react';
import { DateFieldValue } from 'components/organisms/tasks/field-value';
import type { DateField } from 'components/organisms/tasks/fields';
import type { ClassNameOnlyProps } from 'components/ozone-component';
import { Popover } from './components';

interface Focusable {
  focus: () => void;
}

interface Props<T extends string | number = string> extends ClassNameOnlyProps {
  id?: string;
  field?: DateField<T>;
  title: ReactNode;
  onChange: (latest: T | null) => void;
  disabledDate?: (current: Moment) => boolean;
  value?: string;
  extraFooter?: ReactNode;
  allowClear?: boolean;
}

export class DateFieldEditorPopover extends Component<Props> {
  innerRef = createRef<Focusable>();

  componentDidMount(): void {
    this.focus();
  }

  focus = () => {
    this.innerRef.current?.focus();
  };

  render() {
    const {
      id = 'date_field_editor_wrapper',
      field,
      title,
      onChange,
      className,
      disabledDate,
      value,
      extraFooter,
      allowClear = true,
    } = this.props;

    const { innerRef } = this;

    return (
      <Popover id={id} className={className}>
        <Popover.Title>{title}</Popover.Title>
        <DateFieldValue
          innerRef={innerRef as any}
          field={field}
          value={value}
          editable
          onChange={(latest?: string) => onChange(latest ?? null)}
          getPopupContainer={() => document.getElementById(id) as HTMLElement}
          disabledDate={disabledDate}
          extraFooter={extraFooter}
          allowClear={allowClear}
        />
      </Popover>
    );
  }
}
